import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../../widgets/Head';
import { Text } from '../../widgets/Text';
import Image from '../../widgets/Image';
import Summary from '../../widgets/Summary';
import OpenSourcePage from './OpenSourcePage';

const internLogo = require('../../assets/images/logo/medium/intern.svg');

const factory = create();

export const OpenSourceIntern = factory(function OpenSourceIntern() {
	return (
		<OpenSourcePage background="level3Green">
			{{
				head: (
					<Head
						title="Intern | SitePen"
						description="An all-in-one solution for full-lifecycle testing of JavaScript and TypeScript applications, supporting Node and modern browsers."
					/>
				),
				hero: {
					title: 'Open Source',
					xlTitle: 'Intern'
				},
				page: (
					<Summary stack paddingBottom="md">
						{{
							image: <Image src={internLogo} size="sm" width={288} height={285} />,
							blurb: (
								<virtual>
									<Text type="large-body">
										Comprehensive testing is a mainstay in effective development
										organizations. Ten years ago, fragmented testing processes
										were causing painful inefficiencies at SitePen and in the
										greater developer community. Recognizing the need for high
										quality testing in the enterprise prompted us to create and
										open-source Intern, a standards-based browser testing stack
										for JavaScript.
									</Text>
									<Text type="large-body">
										We build tools like Intern because we know that when we can
										eliminate pain points and give developers better tools, they
										will use them. Creating tools like Intern allows us to
										improve the developer experience, making it easier for them
										to follow best practices and promoting engineer discipline
										across organization. Ultimately, it’s a win-win for the
										developer and their company. Useful tools lead to happier
										developers and happy developers build sustainable, high
										quality applications.
									</Text>
								</virtual>
							)
						}}
					</Summary>
				)
			}}
		</OpenSourcePage>
	);
});

export default OpenSourceIntern;
